import { Outlet, Navigate } from '@hydrogen/elements.core.router';
import BaseLayout from '@hydrogen/elements.ui.layouts.base';
import { Header } from 'widgets/Header';
import Footer from 'components/Footer';
import { information } from './routes/information';
import { documents } from './routes/documents';
import { dashboard } from './routes/dashboard';
import { investmentDetail } from './routes/investment-detail';
import { activation } from './routes/activation';
import { resetPassword } from './routes/reset-password';
import { login } from './routes/login';
import { imprint } from './routes/imprint';
import { disclaimer } from './routes/disclaimer';
import { kontakt } from './routes/kontakt';
import { dataProtection } from './routes/data-protection';
import { bfsg } from './routes/bfsg';

const home = '/';

export const routingConfig = [
    {
        Component: BaseLayout,
        props: {
            header: <Header
                navigations={[
                    {
                        label: 'nav.overview',
                        link: '',
                    },
                    {
                        label: 'nav.documents',
                        link: 'documents/',
                    },
                    {
                        label: 'nav.information',
                        link: 'information/',
                    },
                ]}
            />,
            children: <Outlet />,
            footer: <Footer />,
        },
        url: '/',
        breadcrumb: 'dashboard',
        children: [
            dashboard,
            documents,
            information,
            investmentDetail,
            imprint,
            disclaimer,
            kontakt,
            dataProtection,
            bfsg,
            {
                Component: () => <Navigate replace to={home} />,
                url: '',
            },
        ],
    },
    {
        Component: BaseLayout,
        props: {
            children: <Outlet />,
            footer: <Footer />,
        },
        url: '/',
        children: [
            activation,
            resetPassword,
            login,
        ],
    },
    {
        Component: () => <div>404</div>,
        url: '*',
    },
];
